export enum ConfirmActions {
    ResendInvitationEmail = 1,
    SendDashboardLink = 2,
}